import Vue from "vue";
import axios from "axios";
import {ConfigProvider} from "@/ConfigProvider";


export function EqifyApplicationPlugin(vue: typeof Vue, options?: any): void {
    registerVersionPoller(vue, options?.interval || 10 * 60 * 1000)
    window.addEventListener("visibilitychange", () => {
        if (!document.hidden) {
            fetchVersion(vue)
        }
    })
}

async function registerVersionPoller(vue: typeof Vue, interval: number) {
    fetchVersion(vue)
    setInterval(async () => {
        await fetchVersion(vue)
    }, interval)
}

async function fetchVersion(vue: typeof Vue) {
    vue.prototype.$version = await checkVersion(vue.prototype.$version)
}

async function checkVersion(previousVersion: ApplicationVersion | undefined): Promise<ApplicationVersion> {
    try {
        const apiVersion = (await axios.get(ConfigProvider.serviceBaseUrl + "/../_/system/version")).data
        const appVersion = (await axios.get(ConfigProvider.serviceBaseUrl + "/../version.txt")).data
        const version = {
            app: appVersion,
            api: apiVersion,
            lastChecked: new Date(),
            isChanged: false
        } as ApplicationVersion
        if (previousVersion) {
            version.isChanged = previousVersion.isChanged || previousVersion.app != appVersion || previousVersion.api != apiVersion
        }
        return version
    } catch (e) {
        return {
            app: "",
            api: "",
            lastChecked: undefined,
            isChanged: false
        } as ApplicationVersion
    }
}

export interface ApplicationVersion {
    app: string
    api: string
    lastChecked: Date | undefined
    isChanged: boolean
}

declare module 'vue/types/vue' {
    interface Vue {
        $version: ApplicationVersion,
    }
}
